import { render, staticRenderFns } from "./studentScoreGrading.vue?vue&type=template&id=509ed5ee&"
import script from "./studentScoreGrading.vue?vue&type=script&lang=js&"
export * from "./studentScoreGrading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports